import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "cycles/new",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import(/* webpackChunkName: "snp" */ "./components")]).then(
        ([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
